<section class="operations-shell">
  <div class="operations-view">
  <div class="operations-tabs" role="tablist" aria-label="Operational View">
    <button
      id="tenant-solutions-tab"
      type="button"
      role="tab"
      [attr.aria-selected]="activeOperationsTab === 'tenant-solutions'"
      aria-controls="tenant-solutions-panel"
      (click)="selectOperationsTab('tenant-solutions')"
    >
      Tenant Solutions
    </button>
    <button
      id="resource-graph-tab"
      type="button"
      role="tab"
      [attr.aria-selected]="activeOperationsTab === 'resource-graph'"
      aria-controls="resource-graph-panel"
      (click)="selectOperationsTab('resource-graph')"
    >
      Resource Graph
    </button>
  </div>

  <section
    id="tenant-solutions-panel"
    class="operations-tab-panel"
    role="tabpanel"
    aria-labelledby="tenant-solutions-tab"
    [hidden]="activeOperationsTab !== 'tenant-solutions'"
  >
    <section class="tenant-solution-context" data-testid="tenant-solution-context">
      <header>
        <h3>Tenant Solutions</h3>
        <span class="source-status">{{ tenantSolutionContextStatus() }}</span>
      </header>
    <p *ngIf="tenantSolutionsLoading">Loading SaaS and Datastorio Tenant Solution records independently…</p>
    <ng-container *ngIf="!tenantSolutionsLoading && tenantSolutionsResult as result">
      <p class="retrieved-at">
        SaaS {{ sourceStatus(false, result.saas) }} · Resources {{ sourceStatus(false, result.resources) }}
      </p>
      <p class="source-error" *ngIf="result.saas.error">SaaS: {{ result.saas.error.message }}</p>
      <p class="source-error" *ngIf="result.resources.error">Resources: {{ result.resources.error.message }}</p>
      <p *ngIf="!result.contexts.length">No Tenant Solution source records were returned.</p>
      <article *ngFor="let context of result.contexts" class="tenant-solution-record" [attr.data-match-status]="context.match_status">
        <header>
          <strong>{{ context.saas_record?.solution_id || context.saas_record?.name || context.resource_records[0]?.solution_name }}</strong>
          <span>{{ context.match_status === 'matched' ? 'Matched' : context.match_status }}</span>
        </header>
        <dl>
          <div>
            <dt>Tenant Solution state</dt>
            <dd>{{ context.saas_record?.state || 'No SaaS counterpart' }}</dd>
          </div>
          <div *ngIf="!context.resource_records.length">
            <dt>Datastorio Tenant Solution state</dt>
            <dd>No Datastorio Tenant Solution counterpart</dd>
          </div>
        </dl>
        <div class="tenant-solution-actions">
          <a
            *ngIf="context.saas_record?.solution_id"
            [href]="tenantSolutionManagementUrl(context.saas_record?.solution_id)"
          >
            Manage Tenant Solution
          </a>
        </div>
        <details *ngIf="context.saas_record">
          <summary>Raw SaaS Tenant Solution record</summary>
          <button type="button" class="copy-button" (click)="copy(context.saas_record.raw)">Copy raw record</button>
          <pre>{{ context.saas_record.raw | json }}</pre>
        </details>
        <section *ngIf="context.resource_records.length" class="tenant-solution-resources">
          <h4>Exact Datastorio Tenant Solution records ({{ context.resource_records.length }})</h4>
          <article *ngFor="let resource of context.resource_records">
            <dl>
              <div><dt>Component</dt><dd>{{ resource.component_id }}</dd></div>
              <div><dt>Native state</dt><dd>{{ resource.state || 'State not recorded' }}</dd></div>
            </dl>
            <button type="button" (click)="inspectTenantSolution(resource)">Inspect Resource Graph node</button>
            <details>
              <summary>Raw Datastorio Tenant Solution record</summary>
              <button type="button" class="copy-button" (click)="copy(resource.raw)">Copy raw record</button>
              <pre>{{ resource.raw | json }}</pre>
            </details>
          </article>
        </section>
      </article>
    </ng-container>
    </section>
  </section>

  <section
    id="resource-graph-panel"
    class="operations-tab-panel resource-graph-tab-panel"
    role="tabpanel"
    aria-labelledby="resource-graph-tab"
    [hidden]="activeOperationsTab !== 'resource-graph'"
  >
  <div class="source-grid">
    <section class="resources-view" data-testid="resources-source">
      <app-resource-graph-workspace
          [tenantId]="tenantId"
          [refreshing]="resourcesLoading || resourceGraphRefreshing"
          [refreshError]="resourceGraphRefreshError"
          [rows]="graphRows"
          [selectedNode]="selectedNode"
          [inspectionTrail]="inspectionTrail"
          (nodeSelected)="selectOwnershipTreeNode($event)"
          (componentToggled)="toggleComponent($event)"
          (referenceSelected)="selectReferencedComponent($event)"
          (inspectionTrailStopSelected)="selectInspectionTrailStop($event)"
          (refreshRequested)="refreshResourceGraph()"
        >

          <section ownership-tree-status class="detached-components-status" data-testid="ownership-tree-status" *ngIf="resourcesLoading || resourceGraphRefreshing">
            <p class="detached-components-loading">
              <span class="detached-components-spinner" role="status" aria-label="Loading Datastorio SaaS Tenant Ownership Tree"></span>
              Loading Datastorio SaaS Tenant Ownership Tree…
            </p>
          </section>

          <section detached-components-status class="detached-components-status" data-testid="detached-components-status" *ngIf="resourcesLoading || resourceGraphRefreshing || (resourcesResult?.status === 'ready' && !resourcesResult?.data?.detached_root_component_ids?.length)">
            <p class="detached-components-loading" *ngIf="resourcesLoading || resourceGraphRefreshing">
              <span class="detached-components-spinner" role="status" aria-label="Loading Detached Components"></span>
              Loading Detached Components…
            </p>
            <p *ngIf="resourcesResult?.status === 'ready' && !resourcesResult?.data?.detached_root_component_ids?.length">No detached roots.</p>
          </section>

          <div resource-tray class="resource-details-footer">
            <header class="resource-tray-header">
              <h4
                *ngIf="selectedNode as node"
                class="selected-resource-title"
                data-testid="selected-resource-title"
              >
                <span class="selected-resource-type">{{ node.native_type || 'Type not recorded' }}</span>
                <span class="selected-resource-separator" aria-hidden="true">·</span>
                <span class="selected-resource-name">{{ componentIdentifier(node) }}</span>
              </h4>
              <div class="resource-footer-tabs" role="tablist" aria-label="Resource evidence">
                <button
                  id="resource-details-tab"
                  type="button"
                  role="tab"
                  [attr.aria-selected]="activeResourceFooterTab === 'resource-details'"
                  aria-controls="resource-details-panel"
                  (click)="selectResourceFooterTab('resource-details')"
                >
                  Resource details
                </button>
                <button id="dependencies-tab" type="button" role="tab" [attr.aria-selected]="activeResourceFooterTab === 'dependencies'" aria-controls="dependencies-panel" (click)="selectResourceFooterTab('dependencies')">Dependencies</button>
                <button
                  id="jobs-tab"
                  type="button"
                  role="tab"
                  [attr.aria-selected]="activeResourceFooterTab === 'jobs'"
                  aria-controls="jobs-panel"
                  (click)="selectResourceFooterTab('jobs')"
                >
                  Jobs evidence
                </button>
                <button id="cloudwatch-tab" type="button" role="tab" [attr.aria-selected]="activeResourceFooterTab === 'cloudwatch'" aria-controls="cloudwatch-panel" (click)="selectResourceFooterTab('cloudwatch')">CloudWatch</button>
              </div>
            </header>
            <section
              id="resource-details-panel"
              class="resource-inspector"
              role="tabpanel"
              aria-labelledby="resource-details-tab"
              *ngIf="activeResourceFooterTab === 'resource-details'"
            >
              <div class="resource-inspector-body">
                <p *ngIf="!selectedNode">No Component or Construct selected.</p>
                <ng-container *ngIf="selectedNode as node">
                  <section class="source-error" *ngIf="node.kind === 'component' && branchError(node.component_id) as error">
                    <p>{{ error }}</p>
                    <button type="button" class="retry-component" (click)="retryComponent(node.component_id)">Retry retrieval</button>
                  </section>
                  <dl class="resource-operational-summary" data-testid="resource-operational-summary">
                    <div>
                      <dt>Kind</dt>
                      <dd>{{ node.kind | titlecase }}</dd>
                    </div>
                    <div>
                      <dt>Recorded state</dt>
                      <dd>{{ node.state || 'State not recorded' }}</dd>
                    </div>
                  </dl>

                  <section>
                    <h5>Identifiers</h5>
                    <dl class="inspector-list">
                      <div *ngFor="let identifier of node.identifiers | keyvalue">
                        <dt>{{ identifier.key }}</dt>
                        <dd>
                          <button
                            type="button"
                            class="copy-icon-button"
                            [attr.aria-label]="'Copy ' + identifier.key + ' identifier'"
                            [attr.title]="'Copy ' + identifier.key + ' identifier'"
                            (click)="copy(identifier.value)"
                          >
                            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                              <rect x="9" y="9" width="11" height="11" rx="2"></rect>
                              <rect x="4" y="4" width="11" height="11" rx="2"></rect>
                            </svg>
                          </button>
                          <code>{{ identifier.value }}</code>
                        </dd>
                      </div>
                    </dl>
                  </section>

                  <details data-testid="properties-evidence">
                    <summary>Properties</summary>
                    <pre>{{ node.properties | json }}</pre>
                  </details>
                  <details data-testid="raw-resources-evidence">
                    <summary>Exact raw Resources rows ({{ node.raw.length }})</summary>
                    <button
                      type="button"
                      class="copy-icon-button"
                      aria-label="Copy exact raw Resources rows"
                      title="Copy exact raw Resources rows"
                      (click)="copy(node.raw)"
                    >
                      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                        <rect x="9" y="9" width="11" height="11" rx="2"></rect>
                        <rect x="4" y="4" width="11" height="11" rx="2"></rect>
                      </svg>
                    </button>
                    <pre>{{ node.raw | json }}</pre>
                  </details>
                </ng-container>
              </div>
            </section>
            <section id="dependencies-panel" class="resource-inspector dependencies-evidence" role="tabpanel" aria-labelledby="dependencies-tab" *ngIf="activeResourceFooterTab === 'dependencies'">
              <div class="resource-inspector-body">
                <p *ngIf="!selectedNode || selectedNode.kind !== 'component'">Select a Component to inspect its direct Dependency References.</p>
                <ng-container *ngIf="selectedNode?.kind === 'component'">
                  <section *ngIf="revealingDependencyTargetId" class="resource-graph-route-status" role="status">
                    <strong>Revealing Resource Graph Route</strong>
                    <p>Loading and expanding the route to the selected Component…</p>
                  </section>
                  <section *ngIf="resourceGraphRouteStatus as status" class="resource-graph-route-status" role="status">
                    <strong>{{ status.kind === 'not_found' ? 'Resource Graph Route not found' : 'Resource Graph Route unavailable' }}</strong>
                    <p>{{ status.message }}</p>
                  </section>
                  <section *ngIf="dependencyOrigins.length" class="dependency-origin">
                    <div>
                      <span>Inspection origin</span>
                      <code>{{ componentIdentifier(dependencyOrigins[dependencyOrigins.length - 1].node) }}</code>
                    </div>
                    <button type="button" (click)="returnToDependencyOrigin()">Return to origin</button>
                  </section>
                  <section class="dependency-loading-status" data-testid="dependency-loading-status" *ngIf="outgoingDependencyState === 'loading'">
                    <p class="dependency-loading">
                      <span class="dependency-spinner" role="status" aria-label="Loading outgoing dependency evidence"></span>
                      Loading outgoing Dependency References…
                    </p>
                  </section>
                  <section class="source-error" *ngIf="dependencyError">
                    <p>{{ dependencyError }}</p>
                    <button type="button" (click)="retryComponent(selectedNode?.component_id || '')">Retry outgoing Dependency References</button>
                  </section>
                  <p *ngIf="outgoingDependencyState === 'empty'">No outgoing Dependency References.</p>
                  <h5 *ngIf="dependencySummaries.length">Depends on</h5>
                  <app-resource-tray-card *ngFor="let summary of dependencySummaries">
                    <div tray-card-content class="dependency-card-content">
                      <header>
                        <div>
                          <span class="dependency-card-label">Component</span>
                          <code>{{ componentIdentifierFromId(summary.source_reference.target_component_id) }}</code>
                        </div>
                        <span class="dependency-state" *ngIf="summary.status === 'ready'">{{ summary.target?.state || 'State not recorded' }}</span>
                      </header>
                      <dl *ngIf="summary.status === 'ready'">
                        <div><dt>Component type</dt><dd>{{ summary.target?.native_type || summary.source_reference.target_native_type || 'Type not recorded' }}</dd></div>
                        <div><dt>Recorded state</dt><dd>{{ summary.target?.state || 'State not recorded' }}</dd></div>
                        <div><dt>Solution Relationship</dt><dd>{{ summary.solution_relationship }}</dd></div>
                      </dl>
                      <p class="source-error" *ngIf="summary.status === 'unavailable'">{{ summary.error?.message }}</p>
                    </div>
                    <button *ngIf="summary.status === 'ready' && summary.target" tray-card-command type="button" [attr.aria-label]="'Inspect Component ' + componentIdentifierFromId(summary.target.component_id)" title="Inspect Component" (click)="inspectDependencyTarget(summary.target.component_id)">
                      <span *ngIf="revealingDependencyTargetId === summary.target.component_id" class="dependency-spinner" role="status" aria-label="Revealing Component"></span>
                      <svg *ngIf="revealingDependencyTargetId !== summary.target.component_id" viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z"></path><circle cx="12" cy="12" r="2.7"></circle></svg>
                    </button>
                    <details tray-card-evidence class="dependency-reference-details"><summary aria-label="Show exact Dependency Reference" title="Exact Dependency Reference"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6"></path></svg></summary><pre>{{ summary.source_reference.raw | json }}</pre></details>
                  </app-resource-tray-card>
                  <section class="dependency-loading-status" *ngIf="inboundDependencyState === 'loading'">
                    <p class="dependency-loading"><span class="dependency-spinner" role="status" aria-label="Loading dependent Components"></span>Loading Dependent Components…</p>
                  </section>
                  <section class="source-error" *ngIf="inboundDependencyState === 'error'">
                    <p>{{ inboundDependencyError }}</p>
                    <button type="button" (click)="retryDirectDependency(selectedNode?.component_id || '')">Retry Dependent Components</button>
                  </section>
                  <p *ngIf="inboundDependencyState === 'empty'">No Dependent Components.</p>
                  <h5 *ngIf="dependentSummaries.length">Depended on by</h5>
                  <app-resource-tray-card *ngFor="let summary of dependentSummaries">
                    <div tray-card-content class="dependency-card-content">
                      <header>
                        <div>
                          <span class="dependency-card-label">Declaring Component</span>
                          <code>{{ componentIdentifierFromId(summary.source_reference.source_component_id) }}</code>
                        </div>
                        <span class="dependency-state" *ngIf="summary.status === 'ready'">{{ summary.target?.state || 'State not recorded' }}</span>
                      </header>
                      <dl *ngIf="summary.status === 'ready'"><div><dt>Solution Relationship</dt><dd>{{ summary.solution_relationship }}</dd></div></dl>
                      <p class="source-error" *ngIf="summary.status === 'unavailable'">{{ summary.error?.message }}</p>
                    </div>
                    <button *ngIf="summary.status === 'ready'" tray-card-command type="button" [attr.aria-label]="'Inspect Component ' + componentIdentifierFromId(summary.source_reference.source_component_id)" title="Inspect Component" (click)="inspectDependencyTarget(summary.source_reference.source_component_id)">
                      <span *ngIf="revealingDependencyTargetId === summary.source_reference.source_component_id" class="dependency-spinner" role="status" aria-label="Revealing Component"></span>
                      <svg *ngIf="revealingDependencyTargetId !== summary.source_reference.source_component_id" viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z"></path><circle cx="12" cy="12" r="2.7"></circle></svg>
                    </button>
                    <details tray-card-evidence class="dependency-reference-details"><summary aria-label="Show exact Dependency Reference" title="Exact Dependency Reference"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6"></path></svg></summary><pre>{{ summary.source_reference.raw | json }}</pre></details>
                  </app-resource-tray-card>
                </ng-container>
              </div>
            </section>
            <section
              id="jobs-panel"
              class="resource-inspector jobs-evidence"
              role="tabpanel"
              aria-labelledby="jobs-tab"
              *ngIf="activeResourceFooterTab === 'jobs'"
            >
              <header class="evidence-heading">
                <div><h5>Jobs evidence</h5><span class="retrieved-at">{{ jobsResult ? 'Retrieved ' + jobsResult.retrieved_at : '' }}<span *ngIf="jobsLoading" class="timestamp-spinner" role="status" aria-label="Refreshing Jobs evidence"></span></span></div>
                <span class="source-status" [class.live-status]="isCorollaryLive()">{{ corollaryStatus('jobs') }}</span>
              </header>
              <section class="evidence-action-shelf" data-testid="jobs-evidence-action-shelf" aria-label="Jobs investigation controls">
                <nav class="evidence-scope" aria-label="Correlation filter" *ngIf="correlationSelectionLoading || jobsCorrelations.length">
                  <span class="evidence-scope-label">Correlation</span>
                  <button type="button" [class.selected]="!selectedCorrelationId" (click)="showAllCorrelations()">All attempts</button>
                  <button
                    *ngFor="let correlation of jobsCorrelations"
                    type="button"
                    class="jobs-correlation"
                    [class.selected]="isCorrelationFocused(correlation.correlation_id)"
                    (click)="openCorrelation(correlation.correlation_id)"
                  >
                    {{ correlation.correlation_id }}
                  </button>
                </nav>
                <div class="evidence-actions">
                  <button type="button" class="refresh-action" (click)="refreshCorollaryModule('jobs')"><svg class="action-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M20 12a8 8 0 1 1-2.34-5.66"/><path d="M20 4v6h-6"/></svg>Refresh</button>
                  <button type="button" class="live-action" [attr.aria-pressed]="isCorollaryLive()" (click)="setCorollaryLive(!isCorollaryLive())">Live selected scope</button>
                </div>
              </section>
              <div class="resource-inspector-body">
                <p *ngIf="!selectedNode">Select a Component or Construct with an exact resource identifier, or open an exact Correlation URL, to load Jobs evidence.</p>
                <p *ngIf="jobsLoading">Loading Jobs evidence independently…</p>
                <ng-container *ngIf="!jobsLoading && jobsResult as result">
                <p class="source-error" *ngIf="result.error">{{ result.error.message }}</p>
                <p *ngIf="result.status === 'not_found'">No recorded Dispatch Attempts were found.</p>
                <ng-container *ngIf="result.status === 'ready' && result.data as jobs">
                  <article *ngFor="let attempt of jobsAttempts()" class="dispatch-attempt">
                    <header>
                      <strong>{{ attempt.lifecycle_phase || 'Lifecycle phase not recorded' }}</strong>
                      <time>{{ attempt.recorded_at || 'Recorded time not available' }}</time>
                    </header>
                    <p class="attempt-target">{{ attempt.target_component_id || 'Target Component not recorded' }}</p>
                    <details>
                      <summary>Attempt details</summary>
                      <dl>
                        <div><dt>Correlation</dt><dd>{{ attempt.correlation_id }}</dd></div>
                        <div><dt>Source resource</dt><dd>{{ attempt.causation_link.source_resource_id || 'Not recorded' }}</dd></div>
                        <div><dt>Source event</dt><dd>{{ attempt.causation_link.source_event || 'Not recorded' }}</dd></div>
                      </dl>
                      <details class="raw-dispatch-attempt">
                        <summary>Raw Jobs row</summary>
                        <button type="button" class="copy-button" (click)="copy(attempt.raw)">Copy raw row</button>
                        <pre>{{ attempt.raw | json }}</pre>
                      </details>
                    </details>
                  </article>
                  <nav *ngIf="jobsPageCount() > 1" aria-label="Jobs pagination"><button type="button" (click)="setJobsPage(jobsPage - 1)" [disabled]="jobsPage === 0">Previous</button><span>Page {{ jobsPage + 1 }} of {{ jobsPageCount() }}</span><button type="button" (click)="setJobsPage(jobsPage + 1)" [disabled]="jobsPage + 1 >= jobsPageCount()">Next</button></nav>
                </ng-container>
                </ng-container>
              </div>
            </section>
            <section id="cloudwatch-panel" class="resource-inspector" role="tabpanel" aria-labelledby="cloudwatch-tab" *ngIf="activeResourceFooterTab === 'cloudwatch'">
              <header class="evidence-heading">
                <div><h5>CloudWatch investigation</h5><span class="retrieved-at">{{ cloudWatchResult ? 'Retrieved ' + cloudWatchResult.retrieved_at : '' }}<span *ngIf="cloudWatchLoading" class="timestamp-spinner" role="status" aria-label="Refreshing CloudWatch evidence"></span></span></div>
                <span class="source-status" [class.live-status]="isCorollaryLive()">{{ corollaryStatus('cloudwatch') }}</span>
              </header>
              <section class="evidence-action-shelf" data-testid="cloudwatch-evidence-action-shelf" aria-label="CloudWatch investigation controls">
                <nav class="evidence-scope" aria-label="Correlation filter" *ngIf="correlationSelectionLoading || jobsCorrelations.length">
                  <span class="evidence-scope-label">Correlation</span>
                  <button type="button" [class.selected]="!selectedCorrelationId" (click)="showAllCorrelations()">All attempts</button>
                  <button
                    *ngFor="let correlation of jobsCorrelations"
                    type="button"
                    class="jobs-correlation"
                    [class.selected]="isCorrelationFocused(correlation.correlation_id)"
                    (click)="openCorrelation(correlation.correlation_id)"
                  >
                    {{ correlation.correlation_id }}
                  </button>
                </nav>
                <div class="evidence-actions">
                  <button type="button" class="refresh-action" (click)="refreshCorollaryModule('cloudwatch')"><svg class="action-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M20 12a8 8 0 1 1-2.34-5.66"/><path d="M20 4v6h-6"/></svg>Refresh</button>
                  <button type="button" class="live-action" [attr.aria-pressed]="isCorollaryLive()" (click)="setCorollaryLive(!isCorollaryLive())">Live selected scope</button>
                </div>
              </section>
              <div class="resource-inspector-body">
                <p *ngIf="!cloudWatchLoading && !cloudWatchResult && jobsCorrelations.length > 1 && !selectedCorrelationId">Select one correlation above to scope the CloudWatch investigation to a single job.</p>
                <p *ngIf="!cloudWatchLoading && !cloudWatchResult && !(jobsCorrelations.length > 1 && !selectedCorrelationId)">Select a Component or Construct to prepare a CloudWatch investigation.</p>
                <p *ngIf="cloudWatchLoading">Loading CloudWatch evidence independently…</p>
                <ng-container *ngIf="!cloudWatchLoading && cloudWatchResult as result">
                <p class="cloudwatch-warning" *ngIf="result.error?.code === 'cloudwatch_logs_expired'">{{ result.error?.message }}</p>
                <p class="source-error" *ngIf="result.error && result.error.code !== 'cloudwatch_logs_expired'">{{ result.error.message }}</p>
                <p *ngIf="result.status === 'not_found'">No contextual CloudWatch link is available for this selection.</p>
                <ng-container *ngIf="result.status === 'ready' && result.data">
                  <p>Job window: {{ result.data.start }} to {{ result.data.end }}</p>
                  <a [href]="result.data.url" target="_blank" rel="noopener">Open CloudWatch Logs Insights ({{ result.data.region }})</a>
                </ng-container>
                </ng-container>
              </div>
            </section>
          </div>
        </app-resource-graph-workspace>
    </section>
  </div>
  </section>
  </div>
</section>
